import { render, staticRenderFns } from "./AddMenuDialog.vue?vue&type=template&id=7a82d7b2&scoped=true&"
import script from "./AddMenuDialog.vue?vue&type=script&lang=ts&"
export * from "./AddMenuDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a82d7b2",
  null
  
)

export default component.exports